/* unplugin-vue-components disabled */import { render } from "./NewLogin.vue?vue&type=template&id=d7616ca4&scoped=true"
import script from "./NewLogin.vue?vue&type=script&lang=js"
export * from "./NewLogin.vue?vue&type=script&lang=js"

import "./NewLogin.vue?vue&type=style&index=0&id=d7616ca4&lang=css"
import "./NewLogin.vue?vue&type=style&index=1&id=d7616ca4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7616ca4"]])

export default __exports__